import { render, staticRenderFns } from "./BtnPop.vue?vue&type=template&id=d7197b6a&scoped=true"
import script from "./BtnPop.vue?vue&type=script&lang=js"
export * from "./BtnPop.vue?vue&type=script&lang=js"
import style0 from "./BtnPop.vue?vue&type=style&index=0&id=d7197b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7197b6a",
  null
  
)

export default component.exports